import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import HomeSectionsTable from '../../components/home_sections/HomeSectionsTable';
import { useTranslation } from 'react-i18next';

const HomeSectionsList = () => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';

    const links = [
        { label: isArabic ? 'الرئيسية' : 'Home', path: '/' },
        { label: isArabic ? 'إدارة المحتوى' : 'CMS', path: '/home-sections' },
        { label: isArabic ? 'أقسام الصفحة الرئيسية' : 'Home Sections', path: '/home-sections', active: true },
    ];

    return (
        <WrapperSection>
            <GlobalBreadcrumbs links={links} />
            <HomeSectionsTable />
        </WrapperSection>
    );
};

export default HomeSectionsList;
